import { createFileRoute } from '@tanstack/react-router'
import { ExtructLookup } from '@/features/admin/extruct-lookup'

export const Route = createFileRoute('/_authenticated/admin/extruct-lookup')({
  component: ExtructLookup,
})
